export default "__VITE_ASSET__CeEEiaX5__"